import axios from 'axios';
import { enableMirage } from '@/utils';

axios.defaults.baseURL = enableMirage()
  ? '/api/v1'
  : import.meta.env.VITE_URL_API_K8S;
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem(`${import.meta.env.VITE_NAME}.token`);
    const companyIdLogged = localStorage.getItem(
      `${import.meta.env.VITE_NAME}.companyIdLogged`
    );

    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
      'api-key': import.meta.env.VITE_API_KEY,
      'Company-Id': config.headers['Company-Id'] || companyIdLogged,
    };

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status == 401) {
      localStorage.removeItem(`${import.meta.env.VITE_NAME}.token`);
      localStorage.removeItem(`${import.meta.env.VITE_NAME}.user`);

      const url = window.location.href.toString().split('/');

      if (url[url.length - 1] != 'login')
        window.location = `${import.meta.env.VITE_URL}/login`;

      return Promise.reject(error);
    }

    if (error.response?.status == 403) {
      window.location = `${import.meta.env.VITE_URL}/configuracoes/assinaturas?status-assinatura=suspensa`;
    }

    return Promise.reject(error);
  }
);

export default axios;
